import { z } from 'zod';

export const SocCrosswalkCodeReplacementSchema = z.object({
  socCode2010: z.string(),
  socCode2019: z.string(),
});
export type SocCrosswalkCodeReplacement = z.infer<typeof SocCrosswalkCodeReplacementSchema>;
